import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/core/stores/auth-store';
import { AuthLoadingScreen } from '@/core/components/loading/AuthLoadingScreen';

interface AuthOnlyRouteProps {
  children: ReactNode;
}

/**
 * AuthOnlyRoute - Simple Auth Guard
 * Only requires authentication, skips operator selection check.
 * Use for admin/utility pages that don't need operator context.
 */
export const AuthOnlyRoute = ({ children }: AuthOnlyRouteProps) => {
  const { isAuthenticated, isInitialized, isLoading } = useAuthStore();

  // Wait for auth to initialize before making any decisions
  if (!isInitialized || isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
